import Header2 from 'elements/Header2';

const Title = Header2.extend`
    margin-top: 0;
`;

export default Title;



// WEBPACK FOOTER //
// ./src/kentico-blocks/SimpleAccordion/Title.jsx